import {v4 as uuidv4} from 'uuid';
import {ContentHomeNoticeVo} from '../../common/shared/api/nicolas/vo/ContentHomeNoticeVo.interface';
import {ContentHomeNotice} from '../generated/types';
import {createLineBannerItem} from './LineBanner';
import {createRecommendEvent} from './RecommendEvent';
import {createSeriesNotice} from './SeriesNotice';
import {createSeriesNoticeListContainer} from './SeriesNoticeListContainer';

export function createContentHomeNotice({
  series_id,
  contentHomeNoticeVo: {
    current_page,
    notice_list,
    total_count,
    related_event_list,
    line_banner_list,
    top_notice,
    is_end,
  },
}: {
  series_id: number;
  contentHomeNoticeVo: ContentHomeNoticeVo;
}): ContentHomeNotice {
  const topNotice = top_notice && createSeriesNotice(top_notice);
  return {
    id: uuidv4(),
    relatedEventList: related_event_list?.map(createRecommendEvent) || [],
    lineBannerList: line_banner_list?.map(createLineBannerItem) || [],
    seriesId: series_id,
    noticeListContainer: createSeriesNoticeListContainer({
      current_page,
      total_count,
      notice_list,
      is_end,
    }),
    topNotice,
  };
}
